import React from "react";
import { AppListing } from "../../../../components/appListing";
import { useGetEducationDataQuery } from "../../../../redux/service/careplan_service";
import { intervationsEducationCols } from "../../constant";

const CareplanEducations = ({ listData = [], loading = false, legacyMode = false }) => {
  const { data, isLoading, isFetching } = useGetEducationDataQuery(undefined, {
    skip: !legacyMode,
  });
  const educationList = legacyMode ? data?.data || [] : listData;
  const isListingLoading = legacyMode ? isLoading || isFetching : loading;

  return (
    <AppListing
      loading={isListingLoading}
      listData={educationList}
      cols={intervationsEducationCols}
    />
  );
};

export default CareplanEducations;
